import { EdgePostMessageRepository } from '@/modules/connect/infra'
import type { PostMessage } from '@/modules/connect/use-cases'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makePostMessage(): PostMessage {
  return new EdgePostMessageRepository(makeSupabaseEdgeHttpClient()).execute
}
